import React from 'react';
import Img from 'gatsby-image';
import injectSheet from 'react-jss';

import Link from '../components/Link';

const Footer = ({ classes }) => {
    return (
        <footer className={classes.container}>
            <span>© 2021-present Clicked, Inc.</span>
        </footer>
    );
};

const styles = {
    container: {
        height: ({ height = '2rem' }) => height,
        margin: '1.12rem 2.64rem 2.7rem 2.64rem',
        '& span': {
            fontSize: '1.06rem',
            color: '#B2B2B2'
        }
    }
};

export default injectSheet(styles)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer.js